export const reducerName = 'LEAGUES_DATES'

const ActionTypes = {
  SET_LEAGUE: 'SET_LEAGUE',
  SET_DATES: 'SET_DATES',
}

const initialState = {
  league: null,
  dates: [],
}

const LeaguesDatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_LEAGUE:
      return {
        ...state,
        league: action.league,
        dates: [],
      }

    case ActionTypes.SET_DATES:
      return {
        ...state,
        dates: action.dates,
      }

    default:
      return { ... state }
  }
}

const setLeagueForDatePickingAction = (league) => ({
  type: ActionTypes.SET_LEAGUE,
  league: league,
})

export const setLeagueForDatePicking = (league) => (dispatch) => {
  dispatch(setLeagueForDatePickingAction(league))
}

export const selectLeagueForDatePicking = state => state?.[reducerName]?.league

export const selectDates = state => state?.[reducerName]?.dates

export const getInitialState = () => initialState

export const namedReducer = { [reducerName]: LeaguesDatesReducer }
